import { FC } from "react";
import { CHAT_CHANNEL_TYPES } from "../constants";
import { useChatContext } from "../contexts/chat.context";
import ChatAvatar from "./chatAvatar";
import { pubnubTimetokenToJsTime } from "../contexts/util/chat";
import { humanReadableTimeDuration } from "../../../utils/dateTime";

type TChatListItemProps = {
  channelId?: string;
  initials: string;
  isFirstItem?: boolean;
  lastMessage?: string;
  onClick?: () => void;
  selected?: boolean;
  smsTimestamp?: number;
  title: string;
  unreadCount?: number;
};

const ChatListItem: FC<TChatListItemProps> = ({
  channelId,
  initials,
  isFirstItem = false,
  lastMessage = null,
  onClick = () => { },
  selected = false,
  smsTimestamp = null,
  title,
  unreadCount = null,
}) => {
  const {
    subscribedChannels,
    conversations,
  } = useChatContext();

  const thisChannel = !!channelId
    ? subscribedChannels.find(channel => channel.channel_id === channelId)
    : null;

  const lastMessageTime =
    !!channelId && conversations[channelId]?.length > 0
      ? pubnubTimetokenToJsTime(conversations[channelId][conversations[channelId].length - 1].timetoken)
      : !!smsTimestamp
        ? new Date(smsTimestamp).getTime()
        : null;
  return (
    <li className={isFirstItem ? '' : 'mt-1 pt-1 border-t border-t-black/5'}>
      <button className={
        "flex items-center w-full px-2 py-2 text-left " +
        `${selected ? 'bg-accent-blue-paleO66 cursor-default' : 'bg-white hover:bg-accent-blue-paleO66'} rounded-md outline-2 -outline-offset-2 focus:outline focus:outline-accent-blue-dark focus-visible:outline focus-visible::outline-accent-blue-dark`
      }
        onClick={onClick}
      >
        <ChatAvatar
          isGroupChat={!!thisChannel && thisChannel?.channel_type === CHAT_CHANNEL_TYPES.GROUP}
          title={initials || title}
        />
        <span className="flex-grow flex flex-col ml-3 overflow-hidden">
          <span className="text-sm font-medium text-accent-blue-dark max-w-full overflow-hidden whitespace-nowrap text-ellipsis">{title}</span>
          <span className="flex ">
            {!!lastMessage && (
              <span className="text-xs text-black/40 leading-4 max-w-full overflow-hidden whitespace-nowrap text-ellipsis">
                {lastMessage}
              </span>
            )}
            {!!lastMessageTime && (
              <span className="ms-1 flex whitespace-nowrap text-xs text-black/40 leading-4">{" "}
                {!!lastMessage && (<><>&bull;</>{" "}</>)}
                {lastMessageTime && humanReadableTimeDuration(new Date().getTime() - lastMessageTime)}
              </span>
            )}
          </span>
        </span>
        {!!unreadCount && (
          <span className="flex-shrink-0 ml-3">
            <span className="bg-accent-blue-dark text-white font-bold text-xs px-2 py-1 rounded-full">
              {unreadCount * 1 > 99 ? '99+' : unreadCount}
            </span>
          </span>
        )}
      </button>
    </li>
  );
}
export default ChatListItem;